import { gql } from 'graphql-request';

const RichTextBlock = gql`
  fragment RichTextBlock on RichTextBlock {
    id
    value
  }
`;

const ImageChooserBlock = gql`
  fragment ImageChooserBlock on ImageChooserBlock {
    img: image {
      title
      lg: rendition(fill: "900x280-c100") {
        url
      }
      sm: rendition(fill: "640x150-c100") {
        url
      }
    }
  }
`;

const LinkBlock = gql`
  fragment LinkBlock on LinkBlock {
    id
    link {
      type: __typename
      ... on PageChooserBlock {
        page {
          id
          url
          title
        }
      }
      ... on URLBlock {
        id
        value
      }
    }
  }
`;

const NamedLinkBlock = gql`
  fragment NamedLinkBlock on NamedLinkBlock {
    id
    linkTitle
    link {
      type: __typename
      ... on PageChooserBlock {
        page {
          id
          url
          title
        }
      }
      ... on URLBlock {
        id
        value
      }
    }
  }
`;

const CustomEmbedBlock = gql`
  fragment CustomEmbedBlock on CustomEmbedBlock {
    id
    title
    embed {
      url
      embed
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { RichTextBlock, ImageChooserBlock, LinkBlock, NamedLinkBlock, CustomEmbedBlock };
